if (!customElements.get('custom-set')) {
  class CustomSet extends HTMLElement {

    constructor() {
      super();

      this.template = document.getElementById('custom-set-template');
      this.shadow = this.attachShadow({ mode: 'closed' });
      this.shadow.appendChild(this.template.content.cloneNode(true));
      this.customSetConfiguration = this.shadow.querySelector('[data-configuration]');
      this.i18n = this.shadow.querySelector('[data-i18n]');

      try {
        this.customSetConfiguration = JSON.parse(this.customSetConfiguration.innerText);
        this.i18n = JSON.parse(this.i18n.innerText);
      } catch (err) {
        console.log(err);
        this.customSetConfiguration = null;
        this.i18n = null;
      }
      if (!this.customSetConfiguration) return;

      this.categories = this.customSetConfiguration.categories;

      this.formId = this.getAttribute('data-form-id');
      this.form = this.closest(`form[id=${this.formId}]`);

      this.bundleMasterProduct = this.customSetConfiguration.bundleMasterProductId;
      this.bundlePriceAdjustmentPercentage = this.customSetConfiguration.bundleAdjustmentValue || 0;
      this.limit = this.customSetConfiguration.limit;
      this.maxProductsPerCategory = this.customSetConfiguration.maxProductsPerCategory;

      this.addToCartBtn = this.form.querySelector('.product-form--add-to-cart');
      
      this.progress = 0;
      this.progressBar = this.shadow.querySelector('.custom-set__progress-bar');
      this.progressCounter = this.shadow.querySelector('.progress-counter .progress-counter__current');
      this.progressLabelCounter = this.shadow.querySelector('.remaining-products-count');

      this.selectedProducts = [];
    }

    get limit() { return Math.abs(this.getAttribute('limit')) ?? this.limitProducts ?? 2; }

    set limit(val) {
      this.limitProducts = val;
      this.setAttribute('limit', val);
    }
    set products(val) { this._products = val; }

    connectedCallback() {
      // Set Add To Cart Button Initial State (Disabled)
      this.addToCartBtn.disabled = this.selectedProducts.length < this.limit;
      
      this.form?.querySelector('.product-form--add-to-cart').addEventListener('click', (e) => {
        e.preventDefault();

        this.getHash().then(data => {
          const token = data.token;
          const hash = data.hash;
          let items = [];
        
          this.selectedProducts.forEach((product, idx) => {
            items.push({
              quantity: 1,
              id: product.id,
              properties: {
                '_bundle_master': false,
                '_bundle': 'item',
                '_hash': hash,
                '_token': token,
                '_bundle_index': idx,
                '_bundle_parent_id': parseInt(this.bundleMasterProduct),
                '_price_decrease_percentage': parseFloat(this.bundlePriceAdjustmentPercentage)
              }
            })
          })
          this.addToCartBtn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: items
            })
          }).then(res => res.json())
          .then(json => {     
            this.updateAndShowDrawer();
            this.addToCartBtn.disabled = false;
          }).catch(err => {
            this.addToCartBtn.disabled = false;
          })
        })
      })

      this.shadow.addEventListener('cs-product-selector:product-selected', this.onProductSelected.bind(this));
      this.shadow.addEventListener('cs-step:product-removed', this.onProductRemoved.bind(this));
    }

    onProductSelected(event) {
      // Check if limit is reached
      if(this.selectedProducts.length >= this.limit) return;

      const product = event.detail.product;
      
      this.selectedProducts.push(product);

      // Sort selected products by position
      this.selectedProducts.sort((a, b) => a.position - b.position);
      
      // Update progress bar and counter
      this.updateProgress();
    }
    
    onProductRemoved(event) {
      const { handle, position } = event.detail;
      this.selectedProducts = this.selectedProducts.filter(el => el.handle !== handle || el.position !== position);

      // Update progress bar and counter
      this.updateProgress();
    }

    updateProgress() {
      this.progress = this.selectedProducts.length / this.limit;
      this.progressBar.value = this.progress * 100;
      this.progressCounter.textContent = this.selectedProducts.length;
      this.progressLabelCounter.textContent = this.limit - this.selectedProducts.length;
      this.toggleAttribute('items-selected', this.selectedProducts.length === this.limit);

      // Validate Add To Cart Button
      this.validateAddToCartBtn();
    }

    validateAddToCartBtn() {
      this.addToCartBtn.disabled = this.selectedProducts.length < this.limit;
    }
    
    updateAndShowDrawer() {
      fetch('/?section_id=cart-drawer')
        .then(r => r.text())
        .then(html => {
          const parser = new DOMParser();
          const parsedDocument = parser.parseFromString(html, "text/html");
          let target = document.querySelector('.cart--root');
          target.innerHTML = parsedDocument.querySelector('.cart--root').innerHTML;
          target.dataset.hasItems = true;
          theme.partials.OffCanvas.right_sidebar.attr('data-active', 'cart');
          if (theme.partials.OffCanvas.state === 'closed') {
            theme.partials.OffCanvas.right_sidebar_view = 'cart';
            theme.partials.OffCanvas.openRight();
          }
        })
    }
    
    async getHash() {
      return new Promise(resolve => {
        let urlParams = new URLSearchParams(window.location.search);
        /**
         * Workaround for product_preview
         * If URL has preview_key use some random other PDP Page to get the hash view
         * -> Doesn't matter on which PDP Page the request is send
         * 
         * -> Else needs to be double checked
         */
        if (urlParams.has('preview_key')) {
          console.log("inside if");
          fetch(`/products/101-kajal-eyeliner-black?view=hash`)
            .then(res => res.json())
            .then(json => {
              resolve(json);
            })
        } else {
          console.log("inside else");
          urlParams.set('view', 'hash');
          let fetch_url = window.location.href.split(`?`)[0] + `?` + urlParams;
          console.log(fetch_url);
          //fetch(urlParams)
          fetch(fetch_url)
            .then(res => res.json())
            .then(json => {
              resolve(json);
            })
        }
      })
    }
  }
  customElements.define('custom-set', CustomSet);
}

/* Custom Set - Step Element */
if (!customElements.get('cs-step')) {
  class CustomSetStep extends HTMLElement {
    constructor() {
      super();

      this.selectedProduct = null;
      this.selectedCategory = null;

      this.backBtn = this.querySelector('.back-btn');
      this.backBtn.addEventListener('click', this.handleBackBtnClick.bind(this));

      this.closeBtn = this.querySelector('.close-btn');
      this.closeBtn.addEventListener('click', this.handleCloseBtnClick.bind(this));
    }

    // Getters
    get categorySelectorsWrapper() {
      return this.querySelector('.category-selectors-wrapper');
    }
    get productsWrapper() {
      return this.querySelector('.products-wrapper');
    }

    connectedCallback() {
      this.setupEventListeners();
    }

    setupEventListeners() {
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('cs-step:clicked', this.selectCategory.bind(this));
      this.addEventListener('cs-category-selector:clicked', this.onCategorySelected.bind(this));
      this.addEventListener('cs-product-selector:product-selected', this.onProductSelected.bind(this));
    }

    handleClick(event) {
      this.dispatchEvent(new CustomEvent('cs-step:clicked', {
        bubbles: true,
        detail: {
          element: this
        }
      }));
    }

    selectCategory(event) {
      if (this.hasAttribute("open")) return;
      
      this.setAttribute("open", "");
      
      // If only one category selector is available, select it automatically
      const selectors = this.querySelectorAll('cs-category-selector');
      if (selectors.length === 1) {
        selectors[0].click();
      }
    }

    handleBackBtnClick(event) {
      event.stopPropagation();

      this.backBtn.parentElement.classList.remove("second-step-active");
      this.categorySelectorsWrapper.classList.remove("hidden");
      this.productsWrapper.classList.add("hidden");
    }

    handleCloseBtnClick(event) {
      event.stopPropagation();

      const { position, selectedProduct } = this.dataset;

      // Reset selected product
      this.selectedCategory = null;
      this.selectedProduct = null;
      this.querySelector('.selected-category').innerHTML = "";
      this.querySelector('.selected-product').innerHTML = "";
      this.removeAttribute("data-selected-product");
    
      // Show category selectors and hide products
      this.removeAttribute("open");
      this.categorySelectorsWrapper.classList.remove("hidden");
      this.productsWrapper.classList.add("hidden");
      this.querySelector('.step-label-wrapper').classList.remove("second-step-active");

      // Remove selected product from collected products
      this.dispatchEvent(new CustomEvent('cs-step:product-removed', {
        bubbles: true,
        composed: true,
        detail: {
          handle: selectedProduct,
          position: parseInt(position)
        }
      }));
    }

    onCategorySelected(event) {
      this.selectedCategory = event.detail.category;     
    }

    onProductSelected(event) {
      this.selectedProduct = event.detail.product;
      
      // Set selected category and product
      this.setAttribute('data-selected-product', this.selectedProduct.handle);
      this.querySelector('.selected-category').innerHTML = this.selectedCategory.title;
      this.querySelector('.selected-product').innerHTML = this.selectedProduct.title;

      // Scroll back to the custom-set element with extra buffer
      requestAnimationFrame(() => {
        const host = this.closest('.cs-wrapper')?.getRootNode()?.host;
        if (host) {
          const rect = host.getBoundingClientRect();
          const buffer = 50;
          window.scrollTo({ top: window.scrollY + rect.top - buffer, behavior: 'smooth' });
        }
      });
    }
  }
  customElements.define('cs-step', CustomSetStep);
}

/* Custom Set - Category Selector */
if (!customElements.get('cs-category-selector')) {
  class CategorySelector extends HTMLElement {
    constructor() {
      super();
    }

    get customSetConfiguration() {
    return this.getRootNode()?.host?.customSetConfiguration;
  }

    get categorySelectorsWrapper() {
      return this.parentElement;
    }

    get productsWrapper() {
      return this.closest('cs-step')?.querySelector('.products-wrapper');
    }

    connectedCallback() {
      this.setupEventListeners();
    }

    setupEventListeners() {
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('cs-category-selector:clicked', this.fetchProducts.bind(this));
    }

    handleClick() {
      this.dispatchEvent(new CustomEvent('cs-category-selector:clicked', {
        bubbles: true,
        detail: {
          category: {title: this.dataset.title, handle: this.dataset.handle}
        }
      }));
    }

    fetchCategoryProducts(handle) {
      // Remove previous products
      const productsWrapper = this.productsWrapper;
      if (productsWrapper) productsWrapper.remove();

      const selectedProducts = Array.from(this.closest('.cs-wrapper').querySelectorAll('cs-step')).filter(el => el.dataset.selectedProduct).map(el => el.dataset.selectedProduct);

      const _url = `/collections/${handle}?view=custom-set`
      fetch(_url).then(res => {
        if (!res.ok) { throw new Error('Something went wrong!\n') }
        return res.text();
      }).then(data => {
        const parser = new DOMParser();
        const shadow = parser.parseFromString(data, 'text/html');
        const shadowSection = shadow.querySelector('.custom-set-selection__tiles');

        const productsListEl = document.createElement('div');
        productsListEl.classList.add('products-wrapper');
        productsListEl.innerHTML = shadowSection.innerHTML;

        // Filter out excluded products
        const excludedProducts = this.customSetConfiguration?.excludedProducts || [];
        Array.from(productsListEl.children).filter(el => excludedProducts.includes(el.dataset.handle)).forEach(el => el.remove());

        this.closest('.content').appendChild(productsListEl);

        // Scroll to the top of the opened panel with extra buffer
        requestAnimationFrame(() => {
          const rect = productsListEl.closest("cs-step").getBoundingClientRect();
          const buffer = 50;
          window.scrollTo({ top: window.scrollY + rect.top - buffer, behavior: 'smooth' });
        });

      }).catch(err => console.log(err));
    }

    fetchProducts(event) {
      const { handle } = event.detail.category;

      // Update step label
      this.closest('cs-step').querySelector('.step-label-wrapper').classList.add('second-step-active');

      // Hide category selectors
      this.categorySelectorsWrapper.classList.add('hidden');

      // Fetch products
      this.fetchCategoryProducts(handle);
    }
  }
  customElements.define('cs-category-selector', CategorySelector);
}

/* Custom Set - Product Selector */
if (!customElements.get('cs-product-selector')) {
  class ProductSelector extends HTMLElement {
    constructor() {
      super();
    }

    get categorySelectorsWrapper() {
      return this.closest('cs-step')?.querySelector('.category-selectors-wrapper');
    }

    get productsWrapper() {
      return this.closest('.products-wrapper');
    }

    connectedCallback() {
      this.setupEventListeners();
    }

    setupEventListeners() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      // Prevent duplicate click from label > input interaction
      if (event.target.closest('input')) return;

      const { id, title, handle } = this.dataset;
      const position = parseInt(this.closest('cs-step').dataset.position);
      this.dispatchEvent(new CustomEvent('cs-product-selector:product-selected', {
        detail: { product: { id, title, handle, position } },
        bubbles: true,
        composed: true
      }));
    }
  }
  customElements.define('cs-product-selector', ProductSelector);
}
